import React, { Component } from 'react';
import Home from '../../container/Home';
import Loader from '../../container/Loader';
import Module from '../../pages/Module';

import api from "../../services/api";
import { getToken, getClient, getId, getUserEmail } from "../../services/auth";

import '../../styles/modulos.css'

class Menu extends Component {
  state = {
    loading: true,
    modules: [],
    url_client: 'cliente/',
	  url_module: 'acesso'
  }

  getModules(token, client, ) {
    
    api.get(this.state.url_client + client, { headers: { token } })
      .then(response => {
        this.setState({
          modules: this.state.modules.length > 0 ?
            this.state.modules.concat(response.data) : response.data,
          loading: false
        })
      }).catch(err => console.log(err));
  }

  getAccess = (idModule, url) => {
    
    const user = getId();
    const email = getUserEmail();
    const client = getClient();
    const module = JSON.parse(idModule);
    const token = getToken();

    api.get(this.state.url_module, 
    {
      params: {
        id_usuario: user, 
        email: email, 
        cliente: client, 
        modulo: module, 
        tokenAtual: token
    }})
    .then((response) => {
      window.open(url+response.data.token, '_blank');
    });
  }

  componentDidMount() {
    this.getModules(getToken(), getClient())
  }


  render() {
    if (this.state.loading) return <Loader />;
    const modules = this.state.modules;
    return (<><Home menu={true} client={true} html={<><Module modules={modules} getAccess={this.getAccess} /></>} /></>);
  }
}

export default Menu;